@if (questionHintData) {
  <div class="sc-dialog-wrapper">
    <div class="m3-dialog-header">
      <mat-icon class="m3-dialog-icon">help</mat-icon>
      <h2 class="m3-dialog-headline">{{ 'assistance' | translate }}</h2>
    </div>
    <!-- --mat-dialog-content-padding: 0 var(--md-sys-size-2); -->
    <!-- --mat-dialog-with-actions-content-padding: 0 var(--md-sys-size-2); -->
    <div
      mat-dialog-content
      style="--mdc-dialog-supporting-text-color: var(--md-sys-color-on-surface)"
    >
      @if (questionHintData.information_image) {
        <div class="img-center">
          <srcset-image
            [src]="baseUrl + questionHintData.information_image"
            class="img-fluid"
            alt=""
          />
        </div>
      }
      @if (questionHintData.information_text) {
        <div
          style="max-width: 64ch"
          [innerHTML]="questionHintData.information_text"
        ></div>
      }
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="close('ok')">
        <mat-icon>close</mat-icon>
        {{ 'Close' | translate }}
      </button>
    </div>
  </div>
}
